import axios from 'axios';
import React, { useState, useEffect } from "react";
import Navigatie from "../../../components/navigaties";
import Footers from "../../../components/footers";
import { Helmet } from "react-helmet";
import { config } from "../../../config"
import { useForm } from 'react-hook-form'
import { AiOutlineArrowLeft } from 'react-icons/ai'
import { useHistory } from "react-router-dom";
import { store } from 'react-notifications-component';
import { AiOutlineDelete } from 'react-icons/ai'
import Switch from '@material-ui/core/Switch/Switch';

function P_Paneel_JS_Inschrijving_Bewerking(props) {

    let history = useHistory();
    
    const [item, setItem] = useState({})
    const [checked, setChecked] = useState({
        'confirmation': false
        
    });

    const handleSwitch = (event) => {
        setChecked({ ...checked, [event.target.name]: event.target.checked });
        
    };

    var link = config.api + "/jobfair/participations/" + props.match.params.id

    useEffect(() => {
        function itemOphalen(getReq){
            axios.get(getReq)
            .then(res => {
                //console.log(res.data.confirmation)
                setChecked({...checked, 'confirmation': res.data.confirmation})
                setItem(res.data)
            })
            .catch(err => {
                //console.log(err)
            })
            
        }

        itemOphalen(link)
        // eslint-disable-next-line
    }, [link])



    const { register, handleSubmit } = useForm();

    // company name
    // company desc

    function onSubmit(values) {
         
        Object.keys(values).forEach(key => {
            if (values[key] === '' || values[key] === null) {
                delete values[key];
            }
        });
        //console.log(values)
        values['confirmation'] = checked.confirmation;
        if(values.contact_telephonenumber === "" && values.contact_cellphonenumber === ""){
            store.addNotification({
                title: "Bewerken mislukt!",
                message: "GSM- of telefoonnummer van contactpersoon moet ingevuld worden!!",
                type: "danger",
                insert: "top",
                container: "top-center",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                    duration: 1000,
                    onScreen: true
                }
            });
            return;
        }  
        
        axios.patch(config.api + '/jobfair/participations/' + item.id, values, {
            headers: {
                'Content-Type': 'application/json'
            },
        }).then(function (response) {
            store.addNotification({
                title: "Bewerken gelukt!",
                message: "Het bewerken van de bedrijfs info is gelukt!",
                type: "default",
                insert: "top",
                container: "top-center",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                    duration: 1000,
                    onScreen: true
                }
            });
            setTimeout(() => {
                window.location.assign(config.base + "/paneel/j&s/inschrijving/" + item.id + "/bewerk");
                }, 1000)
        })
        .catch(function (error) {
            store.addNotification({
                title: "Bewerken mislukt!",
                message: "De pagina wordt herladen!",
                type: "danger",
                insert: "top",
                container: "top-center",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                    duration: 1000,
                    onScreen: true
                }
            });
        });
        

    }

    function verwijderItem(){
            if (window.confirm('Bevestig het verwijderen van ' + item.contact_company_name + '.'))
            {
                axios.delete(config.api + '/jobfair/participations/' + item.id).then(function (response) {
                    window.location.assign(config.base + '/paneel/j&s/inschrijvingen');
                })
                .catch(err => {
                    //console.log(err)
                })
            }
            else
            {
                
            }
        }
    let [claims] = useState(localStorage.getItem('claims') !== null ? JSON.parse(localStorage.getItem('claims')) : null);

    if(claims === null || claims.recruitment_privilege === false){
        window.location.replace("/");
    }else
    return (
        <div>
                <Helmet>
                    <title>HR - Paneel - J&S Inschrijving bewerken</title>
                </Helmet>
            <Navigatie type="other" />

            <div className="mr-v-30 container w-65 xl-w-80 m-w-90">
                <div className="box pd-5">
                    <button onClick={() => history.goBack()} className="c-gray-300 button b-none link t-12 hover hover-2 hover-c-black"><AiOutlineArrowLeft /></button>
                    <h2 className="t-center c-gray-700-90 mr-v-5">{item.contact_company_name} - info bewerken</h2>
                    <form onSubmit={handleSubmit(onSubmit)} className="container w-85 xl-w-90 m-w-100">
                    
                    <label>Aanvaard:</label>
                        <Switch

                            checked={checked.confirmation}
                            onChange={handleSwitch}
                            name="confirmation"
                        />
                    
                    <h2 className="c-gray-700-60 mr-b-5">Facturatie gegevens</h2>
                    <label>Juridische bedrijfsnaam</label>
                    <input defaultValue={item.contact_company_name} {...register("contact_company_name")} name="contact_company_name" type="text" className="text-input pd-2 t-8" placeholder="Juridische bedrijfsnaam" />
      
                    <label>Website</label>
                    <input defaultValue={item.contact_website} {...register("contact_website")} name="contact_website" type="text" className="text-input pd-2 t-8" placeholder="https://www.google.com"/>

                    <label>Facturatie email</label>
                    <input defaultValue={item.contact_billingmail} {...register("contact_billingmail")} name="contact_billingmail" type="email" className="text-input pd-2 t-8" placeholder="Facturatie email" />
                    
                    <label>BTW nummer</label>
                    <input defaultValue={item.contact_btw} {...register("contact_btw")} name="contact_btw" type="text" className="text-input pd-2 t-8" placeholder="BTW nummer" />

            <label>Adres gegevens</label>
            <div className="row">
                <div className="col-10">
                    <input defaultValue={item.contact_street} {...register("contact_street")} name="contact_street" type="text" className="text-input pd-2 t-8 mr-b-0" placeholder="Straat" />        
                </div>
                <div className="col-2 pd-l-1">
                    <input defaultValue={item.contact_number} {...register("contact_number")} name="contact_number" type="text" className="text-input pd-2 t-8 mr-b-0" placeholder="Nr. (Bus)" />        
                </div>
            </div>
            <div className="row">
                <div className="col-7 s-pd-h-0 s-col-12">
                    <input defaultValue={item.contact_city} {...register("contact_city")} name="contact_city" type="text" className="text-input pd-2 t-8" placeholder="Stad/Gemeente" />
                </div>
                <div className="col-2 pd-h-1  s-col-12">        
                    <input defaultValue={item.contact_zipcode} {...register("contact_zipcode")} name="contact_zipcode" type="number" className="text-input pd-2 t-8" placeholder="Postcode" /> 
                </div>
                <div className="col-3 s-col-12">
                    <input defaultValue={item.contact_country} {...register("contact_country")} name="contact_country" type="text" className="text-input pd-2 t-8" placeholder="Land" />   
                </div>
            </div>   
            <h2 className="c-gray-700-60 mr-v-5">Contactpersoon gegevens</h2>    
                    
                    <label>Voornaam</label>
                    <input defaultValue={item.contact_firstname} {...register("contact_firstname")} name="contact_firstname" type="text" className="text-input pd-2 t-8" placeholder="Voornaam" />    

                     <label>Achternaam</label>
                    <input defaultValue={item.contact_lastname} {...register("contact_lastname")} name="contact_lastname" type="text" className="text-input pd-2 t-8" placeholder="Achternaam" />    

                     <label>Email</label>
                    <input defaultValue={item.contact_mail} {...register("contact_mail")} name="contact_mail" type="email" className="text-input pd-2 t-8" placeholder="Email" />    

                    <label>Telefoonnummer</label>
                    <input defaultValue={item.contact_telephonenumber} {...register("contact_telephonenumber")} name="contact_telephonenumber" type="tel" className="text-input pd-2 t-8" placeholder="Telefoonnummer" />             
                    
                    <label>Gsmnummer</label>
                    <input defaultValue={item.contact_cellphonenumber} {...register("contact_cellphonenumber")} name="contact_cellphonenumber" type="tel" className="text-input pd-2 t-8" placeholder="Gsmnummer"/>

                    <label>Functie binnen bedrijf</label>
                    <input defaultValue={item.contact_person_function} {...register("contact_person_function")} name="contact_person_function" type="text" className="text-input pd-2 t-8" placeholder="Functie"/>

                    <label>Vertegenwoordigers:</label>
                    <textarea {...register("contact_extra")} placeholder="Jan Janssens - Jan@bedrijf.be - +32 123 45 67 89" className="text-input pd-2 t-8" rows="10" defaultValue={item.contact_extra}></textarea>
                        
                        <input type="submit" className="button button-s b-blue-400 t-7 c-white fw-500 mr-t-10 mr-b-2" value="BEWERKEN" />
                    
                    
                    </form>
                    <div className="w-100 t-right">
                        <button onClick={verwijderItem} className="button button-m b-red-10 c-red t-12 border-r-10 hover hover-1 hover-b-red hover-c-white"><AiOutlineDelete/></button>
                   </div>
                    
                </div>
            </div>
            <Footers type="main" />
        </div>
    );
}

export default P_Paneel_JS_Inschrijving_Bewerking;
